export const OTROS = { ID: 1, CODIGO: '00' };
export const FACTURA = { ID: 2, CODIGO: '01' };
export const RECIBO_POR_HONORARIOS = { ID: 3, CODIGO: '02' };
export const BOLETA_DE_VENTA = { ID: 4, CODIGO: '03' };
export const LIQUIDACION_DE_COMPRA = { ID: 5, CODIGO: '04' };
export const BOLETOS_DE_TRANSPORTE_AEREO = { ID: 6, CODIGO: '05' };
export const CARTA_DE_PORTE_AEREO = { ID: 7, CODIGO: '06' };
export const NOTA_DE_CREDITO = { ID: 8, CODIGO: '07' };
export const NOTA_DE_DEBITO = { ID: 9, CODIGO: '08' };
export const REQUERIMIENTO = { ID: 88, CODIGO: '' };
export const ORDEN_COMPRA = { ID: 63, CODIGO: '' };
export const VALE_INGRESO = { ID: 86, CODIGO: '' };
export const VALE_SALIDA = { ID: 87, CODIGO: '' };
export const GUIA_REMISION_REMITENTE = { ID: 10, CODIGO: '09' };
export const COTIZACION = { ID: 89, CODIGO: '' }
export const PEDIDO = { ID: 90, CODIGO: '' }
export const ORDEN_PRODUCCION = { ID: 95, CODIGO: '' };
export const ORDEN_SERVICIO = { ID: 93, CODIGO: '' };
export const NOTA_VENTA = { ID: 97, CODIGO: '' };
export const RETENCION = { ID: 21, CODIGO: '20' };
export const GUIA_TRANSPORTISTA = { ID: 32, CODIGO: '31' };
export const CONTROL_CREDITO = { ID: 98, CODIGO: '98' };
export const TRANSFERENCIA = { ID: 96, CODIGO: '' }


export const LISTA_COMPROBANTES = [
    { id: 2, nombre: "FACTURA", CODIGO: '01' },
    { id: 4, nombre: "BOLETA DE VENTA", CODIGO: '01' },
    { id: 97, nombre: "NOTA DE VENTA", CODIGO: '01' },
    { id: 1, nombre: "OTROS", CODIGO: '02' },
    { id: 63, nombre: "ORDEN DE COMPRA", CODIGO: '02' },
]

